import React from 'react';

import { months } from '../assets/options';

import axios from 'axios';

import { token, host, weatherStates, getWeatherIcon, weatherLocations } from '../assets/options';

import RBCarousel from "react-bootstrap-carousel";

class Weather extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            ad: {},
            slider_time: 0
        }
    }

    componentDidMount () {
        this._isMounted = true;

        axios.post(host + '/api/weather/', {}, {headers: {'authorization': token}})
        .then(res => {
            if (res.status === 200) {
                if(this._isMounted)
                    this.setState({
                        data: res.data.data
                    });
            } else {
              const error = new Error(res.data.error);
              throw error;
            }
        })
        .catch(err => console.error(err.response?err.response.data.error:err));

        axios.post(host + '/api/ads/bySize/360x200', {}, {headers: {'authorization': token}})
        .then(res => {
            if (res.status === 200) {
                if (this._isMounted) {
                    this.setState({
                        ad: res.data.data,
                        slider_time: res.data.time
                    });
                }
            } else {
              const error = new Error(res.data.error);
              throw error;
            }
        })
        .catch(err => console.error(err.response ? err.response.data.error : err));
    }

    componentWillUnmount () {
        this._isMounted = false;
    }

    render () {
        const provinces = weatherLocations.filter(loc => loc.key !== 'yerevan');
        const yerevan = this.state.data.yerevan || {};

        const ClimatBlockTop = () => {
            var today = new Date();

            return (
                <div className="ClimatBlock">
                    <div className="ClimatLocation">
                        <p>Այժմ, {today.getDate()} {months[today.getMonth()]}</p>
                    </div>

                    {provinces.map(loc => (
                        <div className="ctdis" key={loc.key}>
                            <p>{loc.name}</p>
                        </div>
                    ))}
                </div>
            );
        }

        const MiddleClimatBlock3 = () => {
            return (
                <div className="MidlleClimatContextBlock">
                    <div className="ContainerMiddle cntend">
                        <p>Խոնավություն` <span className="pl">{yerevan.humidity}%</span></p>
                        <p>Քամու արագություն՝ <span className="pl">{yerevan.wind} կմ/ժ</span></p>
                    </div>

                    {provinces.map(loc => {
                        const locData = this.state.data[loc.key] || {};
                        return (
                            <div className="ctdis eder" key={loc.key}>
                                <p>{locData.state ? weatherStates[locData.state.toLowerCase()] : null}</p>
                            </div>
                        );
                    })}
                </div>
            );
        }

        const MiddleClimatBlock = () => {
            return (
                <div className="MidlleClimatContextBlock">
                    <div className="ContainerMiddle">
                        <p>Երեւան</p>
                        <p>{yerevan.state ? weatherStates[yerevan.state.toLowerCase()] : null}</p>
                    </div>

                {provinces.map(loc => {
                    const locData = this.state.data[loc.key] || {};
                    return (
                        <div className="ctdis eder" key={loc.key}>
                            {locData.state ? <img alt="err" src={getWeatherIcon(locData)}></img> : null}
                        </div>
                    );
                })}
             </div>
            );
        }

        const MiddleClimatBlock2 = () => {
            return(
                <div className="MidlleClimatContextBlock">
                <div className="ContainerMiddle">
                    <p className="sombl">{yerevan.temperature > 0 ? '+' : ''}{yerevan.temperature}</p>
                    {yerevan.state ? <img alt="err" className="ClimatImg" src={getWeatherIcon(yerevan)}></img> : null}
                </div>

                {provinces.map(loc => {
                    const locData = this.state.data[loc.key] || {};
                    return (
                        <div className="ctdis eder mieder" key={loc.key}>
                            <p>{locData.temperature > 0 ? '+' : ''}{locData.temperature}</p>
                        </div>
                    );
                })}

             </div>
            );
        }

        return (
            <div className="ClimateContainer">
            <div className="climat_title">
                Եղանակ
            </div>
            <div className="Climat_Body">
                <div className="climat_context_container">
                    <ClimatBlockTop/>
                    <MiddleClimatBlock/>

                    <div className="BottomClimatContextBlock">
                        <MiddleClimatBlock2/>
                        <MiddleClimatBlock3/>
                    </div>
                </div>

                {this.state.ad.length ? <RBCarousel
                    autoplay={true}
                    pauseOnVisibility={true}
                    slideshowSpeed={this.state.slider_time * 1000}
                    version={4}
                    indicators={false}
                >
                    {this.state.ad.map((item, key) => {
                        return (
                            <a href={item.url} key={key} target="_blank" rel="noopener noreferrer">
                                <div className="climat_Image_Container"
                                style={{backgroundImage: `url(${`${host}/public/uploads/${item.img}`})`}}></div>
                            </a>
                        )
                    })}
                </RBCarousel> : null}
            </div>
        </div>
    );
    }
}

export default Weather
